<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="12">
        <v-row justify="center" align="center">
          <v-col cols="12" md="8">
            <bar-chart :headers="dateUsage.headers" :data="dateUsage.data" />
          </v-col>
          <v-col cols="12" sm="4">
            <v-row dense class="pl-4">
              <v-col cols="6" sm="5" class="font-weight-medium">
                {{ $t("users.infos.activities.created_at") }} :
              </v-col>
              <v-col cols="6" sm="6" class="text-strat">
                {{ infos.created_at ? infos.created_at : "-" }}
              </v-col>
              <v-col cols="6" sm="5" class="font-weight-medium">
                {{ $t("users.infos.activities.last_chat") }} :
              </v-col>
              <v-col cols="6" sm="6" class="text-strat">
                {{ infos.last_chat ? infos.last_chat : "-" }}
              </v-col>
              <v-col cols="6" sm="5" class="font-weight-medium">
                {{ $t("users.infos.activities.last_reco") }} :
              </v-col>
              <v-col cols="6" sm="6" class="text-strat">
                {{ infos.last_reco ? infos.last_reco : "-" }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!---------------------------------->
  </v-container>
</template>

<script>
import BarChart from "@/components/charts/BarChart.vue";

export default {
  name: "StatusChart",
  components: {
    BarChart,
  },
  props: {
    infos: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isActive: false,
      dateUsage: {
        headers: [
          "Sep 2022",
          "Oct 2022",
          "Nov 2022",
          "Dec 2022",
          "Jan 2022",
          "Feb 2023",
        ],
        data: [
          {
            type: "line",
            label: "Liked products",
            borderColor: "hsl(20, 74%, 45%, .5)",
            backgroundColor: "rgb(26, 77, 205)",
            data: [40, 20, 12, 39, 10, 40],
            fill: false,
            borderWidth: 3,
            hoverBorderWidth: 3,
          },
          {
            type: "line",
            label: "Disliked products",
            borderColor: "rgb(250, 0, 150, .3)",
            backgroundColor: "rgb(250, 0, 150)",
            data: [0, 31, 5, 8, 10, 20],
            fill: false,
            borderWidth: 3,
            hoverBorderWidth: 3,
          },
          {
            type: "line",
            label: "Clicked products",
            borderColor: "rgb(100, 0, 44, .5)",
            backgroundColor: "rgb(100, 0, 44)",
            data: [15, 7, 1, 6, 20, 30],
            fill: false,
            borderWidth: 3,
            hoverBorderWidth: 3,
          },
          {
            type: "line",
            label: "Purchased products",
            borderColor: "rgb(14, 200, 44, .5)",
            backgroundColor: "rgb(14, 200, 44)",
            data: [0, 49, 16, 26, 2, 28],
            fill: false,
            borderWidth: 3,
            hoverBorderWidth: 3,
          },
          {
            type: "line",
            label: "Wishlist products",
            borderColor: "rgb(81, 137, 210)",
            backgroundColor: "rgb(14, 100, 144)",
            data: [5, 9, 20, 16, 33, 25],
            fill: false,
            borderWidth: 3,
            hoverBorderWidth: 3,
          },
          {
            type: "bar",
            label: "Usage time By hours",
            backgroundColor: "rgb(14, 100, 144, .5)",
            data: [15, 8, 10, 3, 5, 4],
            barPercentage: 0.8,
            hoverBorderWidth: 3,
          },
        ],
      },
    };
  },
};
</script>

<style>
.chartjs-render-monitor {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
</style>
